module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-4.2dbda75e.jpg";